export default __webpack_public_path__ + "assets/sales-report.45fece39.svg";